module.exports = __webpack_public_path__ + "img/Icon-Accueil.7dc182e0.svg";